import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ROUTE_POINT_FIELDS } from './fieldGroup.config';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'formly-route-point',
  template: `
    <div class="route-point">
      @if (field.props?.label && !field.props?.hideLabel) {
        <h3 class="route-point__title">{{ field.props.label }}</h3>
      }

      <div class="route-point__content">
        @for (fieldItem of field.fieldGroup ?? []; track fieldItem?.id ?? fieldItem?.key ?? $index) {
          <formly-field [field]="fieldItem"></formly-field>
        }
      </div>

      @if (field.props?.description) {
        <p class="route-point__description">{{ field.props.description }}</p>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }

    .route-point {
      display: block;
      width: 100%;
      padding: 0.75rem 0;
    }

    .route-point__title {
      margin: 0 0 0.5rem;
      font-size: 0.95rem;
      font-weight: 600;
    }

    .route-point__content {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .route-point__description {
      margin: 0.5rem 0 0;
      font-size: 0.85rem;
      color: var(--fuse-text-secondary, #6b7280);
    }
  `,
  imports: [FormlyModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyRoutePointComponent extends FieldType implements OnInit {
  ngOnInit(): void {
    if (!this.field.fieldGroup || this.field.fieldGroup.length === 0) {
      this.field.fieldGroup = cloneDeep(ROUTE_POINT_FIELDS);
    }
  }
}
